import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  icon: {
    alignSelf: 'center',
    marginBottom: 10,
  },
  description: {
    alignSelf: 'center',
    marginTop: 10,
  },
  scanCardButton: {
    alignSelf: 'center',
    marginTop: 15,
    width: '90%',
    height: 40,
  },
});
